// extracted by mini-css-extract-plugin
module.exports = {"Loader":"suspenseSpinner_Loader__1q93y","load2":"suspenseSpinner_load2__2n99s","spinnerCon":"suspenseSpinner_spinnerCon__2YuV5"};